//Azeem K : 19-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --Start
import { useDispatch, useSelector } from "react-redux";
import { BzCard, BzModal, BzModalBody, BzModalHeader } from "../../../components";
import { Col, Container, ModalFooter, Row } from "react-bootstrap";
import { memo } from "react";
import { handleModal } from "../../../redux/actions/modals";
import { handleClickOnModernAlgo } from "../../../utils/global_functions";





const arrModernAlgoCards = [
    {
        heading: 'Algo Strategy Builder',
        description: 'Flexibility to create, test and execute custom multi-leg options strategies',
        icon: 'icon-strategy-builder',
        LandingID: '2'
    },
    {
        heading: 'Technical Trading',
        description: 'Modular tools to create, simulate and automate trading strategies',
        icon: 'icon-technical-trading',
        LandingID: '4'

    },
    {
        heading: 'Automated Scalping',
        description: 'Lightning-fast execution and tools like order tickets and automated scalping bots',
        icon: 'icon-automated-scalping',
        LandingID: '3'

    },
];

const ModerAlgoModal = () => {
    const modals = useSelector(state => state?.modals?.modals);
    const dispatch = useDispatch();
    const handleHide = () => {
        dispatch(handleModal([{ "MODERN_ALGO_MODAL": false }]));
    };

    const handleClickOnModernalgoCard = (LandingID) => {
        handleClickOnModernAlgo(dispatch, LandingID);
    };
    return (
        <BzModal size="md" show={modals['MODERN_ALGO_MODAL']} onHide={handleHide} centered >
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div data-testid="alert-modal-close-icon" className='icon-16 icon-close icon-dark' onClick={handleHide} ></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    {arrModernAlgoCards?.map((eachCard) => {
                        return (
                            <Row className='g-0 mb-3'>
                                <Col>
                                    <div className='algo-gradient-card-wrap' onClick={handleClickOnModernalgoCard.bind(this, eachCard?.LandingID)}>
                                        <BzCard className='algo-gradient-card' >
                                            <div className='algo-gradient-icon-wrap flex-shrink-0'>
                                                <div className={`icon-50 ${eachCard?.icon}`}></div>
                                            </div>
                                            <div className='d-flex flex-column gap-2'>
                                                <div className='font-medium font-size4 color-active-text'>{eachCard?.heading}</div>
                                                <div className='font-regular font-size2 color-active-text'>{eachCard?.description}</div>
                                            </div>
                                        </BzCard>
                                    </div>
                                </Col>
                            </Row>
                        );
                    })}
                </Container>
            </BzModalBody>
            <ModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col className="d-flex justify-content-center">
                            <div className='icon-250 icon-modern-algo-color-logo'></div>
                        </Col>
                    </Row>
                </Container>
            </ModalFooter>

        </BzModal>
    );
};

export default memo(ModerAlgoModal);
//Azeem K : 19-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --End
